import { Box, Button, Center, Text } from '@chakra-ui/react'
import { ContainerBase } from './containers/ContainerBase'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/router'

export const ShopNowCard = () => {
  const t = useTranslations()
  const router = useRouter()

  return (
    <Box position="relative" overflow="hidden" bg="black">
      <Box
        zIndex={0}
        position="absolute"
        top="-35%"
        left="50%"
        w="1064px"
        h="1064px"
        rounded="100%"
        background="radial-gradient(65.37% 65.37% at 52.49% 48.96%, #0060FF 0%, #00FFBD 100%);"
        filter="blur(200px)"
        transform={{ base: 'translateX(-10%)', md: 'translateX(-50%)' }}
      ></Box>
      <ContainerBase py="40px">
        <Box
          position="relative"
          zIndex={1}
          px={{ base: '16px', md: '64px' }}
          py={{ base: '24px', md: '64px' }}
          rounded="8px"
          bg="blackAlpha.900"
          maxW="918px"
          mx="auto"
        >
          <Center flexDirection={'column'} justifyItems="center" gap="16px">
            <Text
              variant="spaceGrotesk"
              fontSize="32px"
              lineHeight="normal"
              color="white"
              fontWeight="500"
              maxW="790px"
              textAlign="center"
            >
              {t('hosting-orders.customers-choice')}
            </Text>
            <Text fontSize="24px" color="whiteAlpha.800" textAlign="center">
              {t('hosting-orders.start-mining')}
            </Text>
            <Button
              variant="brandGradient"
              h="48px"
              px="24px"
              maxW="288px"
              w="full"
              fontSize="18px"
              onClick={() => router.push('hardware')}
            >
              {t('buttons.shop-now')}
            </Button>
          </Center>
        </Box>
      </ContainerBase>
    </Box>
  )
}
